<template>
  <Modal
    :id="'cmp-distribution-reports-report_items_form'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t('report_items') }}</template>

    <template slot="body">
      <Dropdown
        style="width: 100%; margin-right: 30px"
        :placeholder="$t('select_report_item')"
        :showLabel="false"
        :selected="moreReportsTV.find((v) => v.value == selectedItemValue)"
        box
        deslect
        v-on:selectedChange="(e) => onDropdownChange(e)"
        :options="moreReportsTV"
      ></Dropdown>
      <div class="item-container">
        <addLabelsItemsForm
          @selected="onReportItemAdded"
          v-if="selectedItemValue == 'add_labels_items_form'"
        />
        <addProductsItemsForm
          @selected="onReportItemAdded"
          v-if="selectedItemValue == 'add_releases_items_form'"
        />
        <addReleasesItemsForm
          @selected="onReportItemAdded"
          v-if="selectedItemValue == 'add_products_items_form'"
        />
        <addTracksItemsForm
          @selected="onReportItemAdded"
          v-if="selectedItemValue == 'add_tracks_items_form'"
        />
        <!-- <button
          class="dt-button v1 s6"
          @click="onAddClick('add_labels_items_form')"
        >
          {{ $dft.snakeCaseToWords("labels") }}
        </button>
        <button
          class="dt-button v1 s6"
          @click="onAddClick('add_releases_items_form')"
        >
          {{ $dft.snakeCaseToWords("releases") }}
        </button>
        <button
          class="dt-button v1 s6"
          @click="onAddClick('add_products_items_form')"
        >
          {{ $dft.snakeCaseToWords("products") }}
        </button>
        <button
          class="dt-button v1 s6"
          @click="onAddClick('add_tracks_items_form')"
        >
          {{ $dft.snakeCaseToWords("tracks") }}
        </button> -->
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onAdd">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { ReportService } from "../../services/reports.service";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import addLabelsItemsForm from "./add-labels-items.vue";
import addProductsItemsForm from "./add-products-items.vue";
import addReleasesItemsForm from "./add-releases-items.vue";
import addTracksItemsForm from "./add-tracks-items.vue";
export default {
  components: {
    SearchList,
    Modal,
    addLabelsItemsForm,
    addProductsItemsForm,
    addReleasesItemsForm,
    addTracksItemsForm,
  },

  data: function () {
    return { selectedItemValue: null, selectedItem: null };
  },

  mounted: function () {},
  computed: {
    moreReportsTV: function () {
      return [
        { text: this.$t("labels"), value: "add_labels_items_form" },
        { text: this.$t("releases"), value: "add_releases_items_form" },
        { text: this.$t("products"), value: "add_products_items_form" },
        { text: this.$t("tracks"), value: "add_tracks_items_form" },
      ];
    },
  },
  methods: {
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onAdd(e) {
      this.$emit("selected", {
        ...this.selectedItem,
      });
    },
    onReportItemAdded(e) {
      this.selectedItem = {
        ...e,
      };
    },
    onDropdownChange(value) {
      this.selectedItem = null;
      this.selectedItemValue = value.value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-reports-report_items_form {
  .item-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    .s6 {
      margin: 10px;
    }
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
}
</style>
